import { IconMap } from '../../../shared/sprite';
import { Icon } from '../../../shared/ui/Icon';
import { FC } from 'react';
import { cn } from '@distribute/frontend/utils';

import { videoCardStyles } from './config';

type VideoCardFailedProps = {
  size?: keyof typeof videoCardStyles;
  className?: string;
};

export const VideoCardLoading: FC<VideoCardFailedProps> = ({
  className = '',
  size = 'sm',
}) => {
  return (
    <div
      className={cn(
        'w-full h-full bg-gray-100 flex flex-col items-center justify-center sm:gap-y-2 gap-y-4 text-center',
        className
      )}
    >
      <Icon
        glyph={IconMap.FilmArrow}
        width={videoCardStyles[size].icon}
        className="text-gray-600"
      />
      <div className="flex flex-col gap-y-1">
        <h5
          className={cn(
            'text-gray-700 font-semibold',
            videoCardStyles[size].header
          )}
        >
          Uploading...
        </h5>
        <p className={cn('text-sm text-gray-500', videoCardStyles[size].text)}>
          Recording will be available soon
        </p>
      </div>
    </div>
  );
};
